<!-- 商城首页 -->
<template>
  <div id="store-home" ref="router1" class="home" name="home">
    <!-- 轮播图 -->
    <div class="block">
      <el-container>
        <!-- <div class="swiper">
          <el-carousel height="450px">
            <el-carousel-item>
              <img src="@/assets/images/store-big-banner.png" alt="">
            </el-carousel-item>
            <el-carousel-item>
              <img src="@/assets/images/store-big-banner.png" alt="">
            </el-carousel-item>
            <el-carousel-item>
              <img src="@/assets/images/store-big-banner.png" alt="">
            </el-carousel-item>
            <el-carousel-item>
              <img src="@/assets/images/store-big-banner.png" alt="">
            </el-carousel-item>
            <el-carousel-item>
              <img src="@/assets/images/store-big-banner.png" alt="">
            </el-carousel-item>
            <el-carousel-item>
              <img src="@/assets/images/store-big-banner.png" alt="">
            </el-carousel-item>
          </el-carousel>
        </div> -->
      </el-container>
      <!-- 广告图 -->
      <div v-for="(t,i) in renderData" :key="i">
        <div v-if="t.length === 3" class="prod-list">
          <div class="three-prod-list">
            <div class="left-img">
              <img :src="t[0].fimagePath" alt="">
            </div>
            <div class="right-img">
              <img style="margin-top:0" :src="t[1].fimagePath" alt="">
              <img :src="t[2].fimagePath" alt="">
            </div>
          </div>
        </div>
        <div v-if="t.length === 4" class="prod-list bottom-prod-list">
          <div>
            <!-- <router-link v-for="(item, index) in t" :key="index" to=""> -->
            <span v-for="(item, index) in t" :key="index">
              <img :class="index < 2 ? 'img-margin' : ''" :src="item.fimagePath" alt="">
            </span>
            <!-- </router-link> -->
          </div>
        </div>
        <div v-if="t.length === 1" class="prod-list">
          <!-- <router-link to=""> -->
          <img style="width:1200px;height:486px" :src="t[0].fimagePath" alt="">
          <!-- </router-link> -->
        </div>
        <div v-if="t.length === 6" class="prod-list sixImgBox">
          <!-- <router-link v-for="(item, index) in t" :key="index" to=""> -->
          <span v-for="(item, index) in t" :key="index">
            <img :class="(index + 2)%3 === 0 ? 'middle-img' : ''" style="width:382px;height:550px" :src="item.fimagePath" alt="">
          </span>
          <!-- </router-link> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import path from '@/utils/path.js'
import { mapGetters } from 'vuex'
import { queryStoreTitleTypeInfo } from '@/api/shop.js'
export default {
  data() {
    return {
      renderData: []
    }
  },
  watch: {
    '$route'(to, from) {
    //   console.log(to, from)
    //   this.onSearch()
    }
  },
  computed: {
    ...mapGetters(['name'])
  },
  /**
   * keep-alive生命周期调用时，改变全局全局宽度
   */
  activated() {
    document.getElementsByClassName('el-main')[0].setAttribute('style', 'width: 100%;max-width:100%')
    document.getElementById('storeApp').setAttribute('style', 'background: #f5f5f5;')
  },
  /**
   * keep-alive生命周期取消掉用，改变全局宽度
   */
  deactivated() {
    document.getElementsByClassName('el-main')[0].removeAttribute('style')
    document.getElementById('storeApp').removeAttribute('style')
  },
  created() {
    this.$nextTick(() => {
      this.onSearch()
    })
  },
  mounted() {
    // this.getRecommend()
    // this.getRecommendList()
    // this.getStockClass() // 获取商品分类信息
    // this.getIndexShopDecoration() // 获取轮播图
  },
  methods: {
    //  去快速求购页面
    toFastBuy() {
      this.$router.push({ path: '/buy/postBuyLeads' })
    },
    goShopCart() {
      this.$router.push({ path: '/shop/shoppingCart' })
    },
    onSearch() {
      this.renderData = []
      const { fid, forder, storeId } = this.$route.query
      const params = new URLSearchParams()
      params.append('FMallStoreId', storeId)
      params.append('StorePageNavigationFID', fid)
      params.append('StorePageNavigationFOrder', forder)
      queryStoreTitleTypeInfo(params)
        .then(res => {
          const arr = []
          res.data.forEach(t => {
            if (arr.indexOf(t.fverticalOrder) === -1) {
              arr.push(t.fverticalOrder)
            }
          })
          const newArr = []
          arr.forEach(s => {
            const list = []
            res.data.forEach(t => {
              if (s === t.fverticalOrder) {
                list.push(t)
              }
            })
            newArr.push(list)
          })
          this.renderData = newArr
        })
    }
  }
}
</script>
<style lang="scss" scoped>
#store-home {
  .swiper{
    width: 100%;
    margin-top: 20px;
  }
  .sixImgBox {
      display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
  .prod-list{
    width: 1200px;
    max-width: 1200px;
    background-color: #fff;
    // padding: 50px 100px;
    margin: 0 auto;
    // margin-top: 60px;
    // margin-bottom: 22px;
    img {
        display: block;
    }
    .middle-img {
        margin: 0 27px;
    }
    .three-prod-list{
      height: 474px;
      display: flex;
      .left-img img{
        width: 760px;
        height: 474px;
      }
      .right-img {
        margin-left: 20px;
        img{
          width: 416px;
          height: 224px;
          margin-top: 22px;
        }
      }
    }

  }
  .bottom-prod-list{
    //   margin-top: 60px;
      height: 1788px;
      img{
        display: inline-block;
        width: 586px;
        height: 880px;
        border: 1px solid #D2D2D2;
      }
      .img-margin{
          margin-bottom: 28px;
      }
      span:nth-child(even){
        margin-left: 14px;
      }
      span:nth-child(odd){
        margin-right: 14px;
      }
    }
}
</style>
<style lang="scss">

#store-home {
  // height: 100%;
  .swiper{
    width: 100%;
  }
  .el-carousel__item{
    width: 100%;
    img {
      width: 100%;
    }
  }
  .el-carousel__button {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    padding: 0;
    background-color: #000;
  }
  .el-carousel__indicator.is-active button{
    background-color: #EC212D;
  }
}
</style>
